import { FC } from 'react';

import { useSelectedProductVariant } from '@telialt/core-eshop/src/hooks/useSelectedProductVariant';
import { ESHOP_TEST_ID } from '@telialt/core-eshop/src/test/test-ids';

import { SummaryContent } from './Summary.styles';

export const Summary: FC = () => {
    const productVariant = useSelectedProductVariant();

    return (
        productVariant?.summary && (
            <SummaryContent dataTest={ESHOP_TEST_ID.ESHOP_PRODUCT_SUMMARY} content={productVariant?.summary} />
        )
    );
};
